import get from 'lodash/get';
import map from 'lodash/map';

export const S3_WITH_BUCKET_POSTFIX_REGEX = /^https?:\/\/s3(.*)?\.amazonaws\.com\/.+?\/(?<resource>.+?)$/i;
// covers formats with a bucket in the relative URL (https://regex101.com/r/tEcMnV/2):
// http(s)://s3.amazonaws.com/bucket/resource
// http(s)://s3.region.amazonaws.com/bucket/resource

export const REGULAR_S3_RESOURCE_REGEX = /^https?:\/\/.+?\.amazonaws\.com\/(?<resource>.+)$/i;
// covers the rest of s3 resource formats (https://regex101.com/r/HpC1zu/4/)
// http(s)://<combinations of region and bucket>.amazonaws.com/resource

export const getSelectorOptions = options => map(options, item => ({ label: item.label, value: item.id }));
export type DropDownOption = ReturnType<typeof getSelectorOptions>;

// plus signs anywhere in a S3 URL are interpreted as spaces
// https://forums.aws.amazon.com/thread.jspa?threadID=55746
export const decodeS3URI = (uri: string) => {
  if (uri.match(S3_WITH_BUCKET_POSTFIX_REGEX) || uri.match(REGULAR_S3_RESOURCE_REGEX)) {
    uri.replace(/\+/g, '%20').replace(/%2B/g, '+');
  }
  return decodeURI(uri);
};

export const getRecordingFileName = (uri = '') => decodeS3URI(uri).split('/').pop() || '';

export const getValueFromURLParameters = (key: string): string | null => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(key);
};

export const getValuesFromStringQuery = (searchString: string, paramName: string): Array<string> => {
  const expression = new RegExp(`(?<=${paramName}:)\\S+`);

  const values = searchString.match(expression);
  return values ? values[0].split(',') : [];
};

export const removeSearchOptionFromStringQuery = (searchString: string, optionToRemove: string) =>
  searchString
    .split(' ')
    .filter(searchWord => {
      return !searchWord.startsWith(`${optionToRemove}:`);
    })
    .join(' ');

export const getAgentDesktopURL = (relativeUrl = '') => {
  // Agent Desktop Admin considers '/' as '/admin'
  // so "window.location" should be used to get the URL base of an Agent Desktop page.
  const agentDesktopUrlOrigin = get(window, 'location.origin', '/');
  return `${agentDesktopUrlOrigin}/${relativeUrl}`;
};

export const getAdminURL = (relativeUrl = 'home') => {
  const agentDesktopUrlOrigin = get(window, 'location.origin', '/');
  return `${agentDesktopUrlOrigin}/admin/${relativeUrl}`;
};

export const isPrimitive = (value): boolean => Object(value) !== value;
